import { render, staticRenderFns } from "./MarketOrderTableVariantProducer.vue?vue&type=template&id=45290bae&"
import script from "./MarketOrderTableVariantProducer.vue?vue&type=script&lang=js&"
export * from "./MarketOrderTableVariantProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports